import { NotFound } from './../components/Common';
import {
  CompositePurchaseDocPage,
  DocEditPage,
  DocPage,
  LoginPage,
  PartnerPage,
  UserManagerPage } from './../pages';
import { RoutePath } from './RoutePath';
import { UserPermission } from './UserPermission';
import { UserRole } from './UserRole';

export enum RouteSection {
  DOCUMENTATION = 'Documentation',
  SETTINGS = 'Settings',
}

export interface IRoute {
  path: string;
  component: any;
  exact: boolean;
  accessControl?: {
    roles?: UserRole[];
    permissions?: UserPermission[];
  };
  menuSettings?: {
    label: string;
    section?: RouteSection;
  };
}

export const Routes: IRoute[] = [
  {
    exact: true,
    path: RoutePath.LOGIN,
    component: LoginPage,
  },
  {
    exact: true,
    path: RoutePath.DOC,
    component: DocPage,
    accessControl: {
      roles: [UserRole.ADMIN, UserRole.PARTNER],
    },
    menuSettings: {
      label: 'Purchase Flow',
      section: RouteSection.DOCUMENTATION,
    }
  },
  {
    exact: true,
    path: RoutePath.DOC_COMPOSITE_PURCHASE,
    component: CompositePurchaseDocPage,
    accessControl: {
      roles: [UserRole.ADMIN],
      permissions: [UserPermission.COMPOSITE_PURCHASE_DOC],
    },
    menuSettings: {
      label: 'Composite Purchase Flow',
      section: RouteSection.DOCUMENTATION,
    }
  },
  {
    exact: true,
    path: RoutePath.DOC_EDIT,
    component: DocEditPage,
    accessControl: {
      roles: [UserRole.ADMIN],
    },
    menuSettings: {
      label: 'Docs Manager',
      section: RouteSection.SETTINGS,
    }
  },
  {
    exact: true,
    path: RoutePath.PARTNERS,
    component: PartnerPage,
    accessControl: {
      roles: [UserRole.ADMIN],
    },
    menuSettings: {
      label: 'Partners',
    }
  },
  {
    exact: true,
    path: RoutePath.USERS,
    component: UserManagerPage,
    accessControl: {
      roles: [UserRole.ADMIN],
    },
    menuSettings: {
      label: 'User Manager',
      section: RouteSection.SETTINGS,
    }
  },
  {
    exact: false,
    path: RoutePath.UNKNOWN_PATH,
    component: NotFound,
  }
];


// WEBPACK FOOTER //
// ./src/constants/Routes.ts